import React, { useEffect, useState } from 'react';
import { ButtonPrimary, Text } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { UbiContactPage } from 'utils/ubi/pages/useUbiContact';

interface MessagingContainerProps {
  onCTA: () => void;
  ubi: UbiContactPage;
}

const MessagingContainer = ({ onCTA, ubi }: MessagingContainerProps) => {
  const { t } = useTranslation();
  const [messagingStarted, setMessagingStarted] = useState(false);

  useEffect(() => {
    ubi.logStartMessagingButtonImpression();
  }, [ubi]);

  const startMessaging = () => {
    setMessagingStarted(true);
    onCTA();
    ubi.logStartMessagingButtonInteraction();
  };

  return (
    <>
      <Text as="h1" paddingBottom="0.75em" variant="titleMedium">
        {t('messaging_header')}
      </Text>
      <Text as="p" paddingBottom="1em" variant="bodyMedium" data-testid="contact-us-body-1">
        {t('messaging_body_1')}
      </Text>
      <Text as="p" paddingBottom="1em" variant="bodyMedium" data-testid="contact-us-body-2">
        {t('messaging_body_2')}
      </Text>
      <ButtonPrimary onClick={startMessaging} disabled={messagingStarted} data-testid="submit-contact-form">
        {t('messaging_cta')}
      </ButtonPrimary>
    </>
  );
};

export default MessagingContainer;
